import React from 'react'
import {ButtonGroup, Dropdown, DropdownButton} from 'react-bootstrap'
import { Link } from 'react-router-dom'
const UserMenuComponent = props => {
  return (
    <DropdownButton as={ButtonGroup} title={<i className="material-icons">menu</i>} >
      <Dropdown.Item as={Link} to={`/contactos-emergencia/${props.id}/${props.name}/${props.type}`}>Contactos de emergencia</Dropdown.Item>
      <Dropdown.Item as={Link} to={`/familiares-dependientes/${props.id}/${props.name}/${props.type}`}>Dependientes económicos</Dropdown.Item>
      <Dropdown.Item as={Link} to={`/familiares-beneficiarios-seguro/${props.id}/${props.name}/${props.type}`}>Beneficiarios</Dropdown.Item>
      <Dropdown.Item as={Link} to={`/educacion-emp/${props.id}/${props.name}/${props.type}`}>Educación</Dropdown.Item>
      <Dropdown.Item as={Link} to={`/salud-mantenimiento/${props.id}/${props.name}/${props.type}`}>Salud</Dropdown.Item>
      <Dropdown.Item as={Link} to={`/historial-laboral/${props.id}/${props.name}/${props.type}`}>Experiencia laboral</Dropdown.Item>
      <Dropdown.Item as={Link} to={`/documentacion-empleados/${props.type}/${props.id}/${props.name}`}>Documentos</Dropdown.Item>
      <Dropdown.Item as={Link} to={`/vacunas-empleados/${props.type}/${props.id}/${props.name}`}>Vacunas</Dropdown.Item>
    </DropdownButton>
  )
}

export default UserMenuComponent
